import { createContext, useContext } from "react";

export const createAppState = (state = {}) => {
  const { isMenuOpen, toggleMenu } = state;
  return {
    isMenuOpen: isMenuOpen || false,
    toggleMenu: toggleMenu || (() => {}),
  };
};

// Create the context
export const AppContext = createContext(createAppState());

// Custom hook for easy context consumption
export const useApp = () => {
  return useContext(AppContext);
};
